import React, { useState } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import newsImage from '../helpers/newsImage';

const NewsImage = ({ news, featured = false, priority = false, sizes, className }) => {
    const image = newsImage(news, featured);
    const [failedWebp, setFailedWebp] = useState(null);
    const useWebp = image.webpSrcSet && failedWebp !== image.webpSrcSet;

    return (
        <picture>
            {useWebp && <source type="image/webp" srcSet={image.webpSrcSet} sizes={sizes} />}
            <img
                src={image.src}
                srcSet={image.srcSet}
                sizes={sizes}
                width={image.width}
                height={image.height}
                alt={news.title || news.titleHome || ''}
                loading={priority ? 'eager' : 'lazy'}
                decoding="async"
                // React 18 forwards the lowercase attribute without an unknown-prop warning.
                // eslint-disable-next-line react/no-unknown-property
                fetchpriority={priority ? 'high' : undefined}
                className={className}
                onError={useWebp ? () => setFailedWebp(image.webpSrcSet) : undefined}
                style={{ width: '100%', height: 'auto', aspectRatio: `${image.width} / ${image.height}`, objectFit: 'cover' }}
            />
        </picture>
    );
};

NewsImage.propTypes = exact({
    news: PropTypes.object.isRequired,
    featured: PropTypes.bool,
    priority: PropTypes.bool,
    sizes: PropTypes.string.isRequired,
    className: PropTypes.string,
});

export default NewsImage;
